import { render, staticRenderFns } from "./ClassifiedListingListItem.vue?vue&type=template&id=2bfc8e1f&"
import script from "./ClassifiedListingListItem.vue?vue&type=script&lang=js&"
export * from "./ClassifiedListingListItem.vue?vue&type=script&lang=js&"
import style0 from "./ClassifiedListingListItem.vue?vue&type=style&index=0&id=2bfc8e1f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports